// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PublicationRead } from "./PublicationRead";
import {
  PublicationReadFromJSON,
  PublicationReadFromJSONTyped,
  PublicationReadToJSON,
  PublicationReadToJSONTyped,
} from "./PublicationRead";

/**
 *
 * @export
 * @interface PagePublicationRead
 */
export interface PagePublicationRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<PublicationRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PagePublicationRead interface.
 */
export function instanceOfPagePublicationRead(value: object): value is PagePublicationRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PagePublicationReadFromJSON(json: any): PagePublicationRead {
  return PagePublicationReadFromJSONTyped(json, false);
}

export function PagePublicationReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PagePublicationRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(PublicationReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PagePublicationReadToJSON(json: any): PagePublicationRead {
  return PagePublicationReadToJSONTyped(json, false);
}

export function PagePublicationReadToJSONTyped(
  value?: PagePublicationRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(PublicationReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
